import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { QidProductDocument } from "server/models"
import {
    StoreType,
    createFileName,
    getFileLogo,
    addModal,
    setDriveOutsideMode,
    setQidProductDocumentReloadList,
} from "client/store"
import {
    TableColumn,
    Link,
    Logo,
} from "client/components"

import FileEdit from "client/pages/drive/fileEdit"

const Columns = (productEditAccess: boolean) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const documentLink = (document: QidProductDocument, linkContent: any) => (
        <Link
            href="/#"
            onClick={() => {
                dispatch(setDriveOutsideMode(true))
                dispatch(addModal({
                    key: "viewDocument",
                    content: <FileEdit fileId={document.fileId} />,
                    onClose: () => {
                        dispatch(setDriveOutsideMode(false))

                        dispatch(setQidProductDocumentReloadList(false))
                        setTimeout(() => {
                            dispatch(setQidProductDocumentReloadList(true))
                        }, 0)
                    },
                }))
            }}
        >
            {linkContent}
        </Link>
    )

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            formatter: (document: QidProductDocument) => document.file.id,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (document: QidProductDocument) => {
                const { file } = document
                return documentLink(
                    document,
                    <Logo table logo={getFileLogo(file, file.versions && file.versions[0])} />,
                )
            },
        },
        {
            field: "file",
            header: lang.file,
            cellMinWidth: "200px",
            formatter: (document: QidProductDocument) => documentLink(document, createFileName(document.file)),
        },
        {
            field: "datapointReference",
            header: lang.datapointReference,
            cellMinWidth: "150px",
            formatter: (document: QidProductDocument) => (document.file.datapointReference ? lang.yes : lang.no),
        },
        // TODO: tempoparily disabled
        /*
        {
            field: "tags",
            header: lang.tags,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            formatter: (document: QidProductDocument) => {
                const tagIds: number[] = []
                if (document.file && document.file.tags) {
                    document.file.tags.forEach((tag) => {
                        tagIds.push(tag.tagId)
                    })
                }
                return (
                    <TagEditor
                        selectedIds={tagIds}
                        tableView
                        readOnly
                    />
                )
            },
        },
        */
    ]

    if (productEditAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
